<script setup>
const props = defineProps(['domainPricing'])

import { usePriceFormat } from '@/composables/priceFormat';
const { formatPrice } = usePriceFormat();
import { FilterMatchMode } from '@primevue/core/api';

const filters = ref({
    tld: {
        filterMode: FilterMatchMode.STARTS_WITH,
        value: ''
    }
});
</script>

<template>
    <DataTable :value="domainPricing"
               v-model:filters="filters"
               paginator
               :rows="10"
               :rowsPerPageOptions="[10,25,50,100]"
    >
        <template #header>
            <div class="flex">
                <IconField>
                    <InputIcon>
                        <i class="pi pi-search" />
                    </InputIcon>
                    <InputText v-model="filters['tld'].value"
                               :placeholder="$t('TLD search')"
                    />
                </IconField>
            </div>
        </template>
        <Column field="tld"
                header="TLD"
                sortable
        />
        <Column field="annual_amount"
                header="Jährlich"
                sortable
        >
            <template #body="slotProps">
                {{ formatPrice(slotProps.data.annual_amount) }}
            </template>
        </Column>
        <Column field="reg"
                header="Registrierung (einmalig)"
                sortable
        >
            <template #body="slotProps">
                {{ formatPrice(slotProps.data.reg) }}
            </template>
        </Column>
        <Column field="kk"
                header="Transfer (einmalig)"
                sortable
        >
            <template #body="slotProps">
                {{ formatPrice(slotProps.data.kk) }}
            </template>
        </Column>
    </DataTable>
</template>
